import { render, staticRenderFns } from "./ControlSidebar.vue?vue&type=template&id=01c82842&scoped=true&"
import script from "./ControlSidebar.vue?vue&type=script&lang=js&"
export * from "./ControlSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c82842",
  null
  
)

export default component.exports